import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { ProjectData, ProjectEvaluationData } from "../../models/project-evaluation.model";
import { ProjectEvaluationRepository } from "../../repositories/project-evaluation.repository";

export class SaveProjectEvaluationUseCase
  implements UseCase<ProjectEvaluationData, ProjectData>
{
  constructor(private repo: ProjectEvaluationRepository) {}
  
  execute(evaluationData: ProjectEvaluationData): Observable<ProjectData> {
    return this.repo.saveProjectEvaluation(evaluationData);
  }
}

const saveProjectEvaluationUseCaseFactory = (repo: ProjectEvaluationRepository) =>
  new SaveProjectEvaluationUseCase(repo);

export const saveProjectEvaluationUseCaseProvider: Provider = {
  provide: SaveProjectEvaluationUseCase,
  useFactory: saveProjectEvaluationUseCaseFactory,
  deps: [ProjectEvaluationRepository],
};
